import type {
  RoomBookingNeedsHostActionCountResponse,
  RoomBookingNeedsUserActionCountResponse,
} from '../models/RoomBooking';

type RoomBookingNeedsActionCountResponse =
  | RoomBookingNeedsHostActionCountResponse
  | RoomBookingNeedsUserActionCountResponse;

/** Prefer dedicated needs-action count; never invent from list rows. */
export function getRoomBookingNeedsActionCountFromResponse(
  response: RoomBookingNeedsActionCountResponse | null | undefined,
): number {
  if (!response) return 0;
  const raw =
    'needsUserActionCount' in response
      ? response.needsUserActionCount
      : response.needsHostActionCount;
  return Math.max(0, raw ?? 0);
}
